import { getSagaContext } from "@modules/store/redux/sagaContext"
import { PayloadAction } from "@reduxjs/toolkit"
import { call } from "typed-redux-saga"
import { UiStoreKeys } from "../storage"

export function* setSidebarCollapsed(action: PayloadAction<boolean>) {
  const storage = yield* getSagaContext("store")
  yield* call(storage.save, UiStoreKeys.SidebarCollapsed, action.payload)
}
